import { Brand } from '@blade/std-lib'

import type { Address } from '@root/entities/address/Address'

export const CurrencyAddressTypeId = 'tradebot-tma/CurrencyAddress'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CurrencyAddressTypeId = typeof CurrencyAddressTypeId

export type CurrencyAddress = Brand.Branded<Address, CurrencyAddressTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrencyAddress = Brand.nominal<CurrencyAddress>()
